export const adaptDocumentoLegal = (documentoLegalData) => {
    return {
        id: documentoLegalData?.idDocumentoLegal,
        displayName: documentoLegalData?.nombre,
        name: documentoLegalData?.nombre
    }
}

export const adaptDocumentoLegalArray = (
    documentosLegales
) => {
    return structuredClone(documentosLegales?.documentoLegalByIdTipoModulo)
        ?.map(documentoLegal => adaptDocumentoLegal(documentoLegal));
}